import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

/**
 * A reusable tile component that displays a header (with a title and an icon)
 * and renders additional children beneath. This component provides a clean white
 * background, light border, rounded corners, padding, and a subtle drop shadow.
 */
const AdvisorDashboardTile = ({ title, icon, children }) => {
  return (
    <Box
      sx={{
        backgroundColor: '#ffffff',
        border: '1px solid #e0e0e0',
        borderRadius: '12px',
        p: 3,
        boxShadow: '0px 1px 3px rgba(0,0,0,0.15)',
        textAlign: 'center',
        width: '369px',
        minHeight: '175px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'left',
          mb: 2,
        }}
      >
        {icon}
        <Typography variant="body1" sx={{ ml: 1 }}>
          {title}
        </Typography>
      </Box>
      {children}
    </Box>
  );
};

AdvisorDashboardTile.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
};

export default AdvisorDashboardTile;
